import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import {
	fileNameInput,
} from './FileUploadField.style';

/**
 * Abstracts the file name display.
 *
 * @export
 * @class FileNameInput
 * @extends {Component}
 */
export default class FileNameInput extends Component {

	constructor(props) {
		super(props);

		const parts = this.props.fileName.split('.');
		let extension;
		let name;
		if (parts.length > 1) {
			extension = parts.pop();
			name = parts.join('.');
		} else {
			extension = '';
			name = this.props.fileName;
		}
		this.state = {
			name: name,
			extension: extension,
			fullName: `${name}.${extension}`
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
		const { value } = event.target;
		this.setState({
			name: value,
			fullName: `${value}.${this.state.extension}`
		});
	}

	render() {
		return (
			<Fragment>
				<input
					style={fileNameInput}
					type="text"
					className="form-control"
					name={`${this.props.name}_edit`}
					id={`${this.props.id}_edit`}
					value={this.state.name}
					onChange={this.handleChange}
				/>
				<input
					type="hidden"
					name={this.props.name}
					id={this.props.id}
					value={this.state.fullName}
				/>
				<Box element="span" pr={2}>
					.{this.state.extension}
				</Box>
			</Fragment>
		);
	}
}

FileNameInput.propTypes = {
	name: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	fileName: PropTypes.string.isRequired,
};
